import { render } from "./ComboBody.vue?vue&type=template&id=85b46414&scoped=true"
import script from "./ComboBody.vue?vue&type=script&lang=js"
export * from "./ComboBody.vue?vue&type=script&lang=js"

import "./ComboBody.vue?vue&type=style&index=0&id=85b46414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b46414"]])

export default __exports__